import {useEffect, useState} from "react";
import {useActive, useAssessment, useSkipAssessment} from "traitify-widgets";
import {setModal} from "common/actions/modal";
import Modal from "common/components/partials/modal";
import useAppContext from "common/hooks/use-app-context";
import useI18n from "common/hooks/use-i18n";
import Instructions from "./instructions";
import RequestAccommodation from "./request-accommodation";
import SelectLocale from "./select-locale";

export default function SurveyModal() {
  const {dispatch, modal} = useAppContext();
  const active = useActive();
  const assessment = useAssessment();
  const {allow: allowSkip, dismiss: dismissSkip, trigger: onSkip} = useSkipAssessment();
  const i18n = useI18n();
  const [requestingAccommodation, setRequestingAccommodation] = useState(false);
  const [step, setStep] = useState(0);
  const closeModal = () => { dispatch(setModal({show: false})); };
  const show = modal.show && modal.type === "Survey";
  const nextStep = () => {
    setStep((currentStep) => currentStep + 1);
  };

  useEffect(() => {
    if(!show) { return; }
    if(step <= 1) { return; }

    closeModal();
  }, [show, step]);

  useEffect(() => {
    if(step !== 1) { return; }
    if(!active) { return; }
    if(active.surveyType !== "cognitive") { return; }

    nextStep();
  }, [active, step]);

  if(!show) { return null; }

  const animated = assessment?.deck_id ? (
    assessment.deck_id.toLowerCase().includes("animated")
    || assessment.deck_id === "big-five-hello-fresh"
    || assessment.deck_id === "big-five-r-and-d"
  ) : false;
  const onContinue = () => {
    if(allowSkip) { dismissSkip(); }

    nextStep();
  };
  const title = i18n.t(requestingAccommodation ? "survey.accommodation.request" : "assessment.instructions");
  const toggleRequestAccommodation = () => setRequestingAccommodation(!requestingAccommodation);

  return (
    <Modal onClose={closeModal} size={animated ? "md" : "sm"} title={title}>
      {step === 0 && <SelectLocale closeModal={closeModal} nextStep={nextStep} />}
      {step === 1 && (
        requestingAccommodation ? (
          <RequestAccommodation back={toggleRequestAccommodation} requestAccommodation={onSkip} />
        ) : (
          <Instructions
            allowSkip={allowSkip}
            animated={animated}
            nextStep={onContinue}
            requestAccommodation={toggleRequestAccommodation}
          />
        )
      )}
    </Modal>
  );
}
